import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../hooks';

export type TransactionUpdateState = {
  hasTransactionUpdate: boolean;
  needToNotify: boolean;
  lastRefreshTime: number;
};

const initialState: TransactionUpdateState = {
  hasTransactionUpdate: false,
  needToNotify: true,
  lastRefreshTime: 0,
};

export const transactionUpdateSlice = createSlice({
  name: 'transactionUpdate',
  initialState,
  reducers: {
    setHasTransactionUpdate: (state, action: PayloadAction<boolean>) => {
      state.hasTransactionUpdate = action.payload;
    },
    setNeedToNotify: (state, action: PayloadAction<boolean>) => {
      state.needToNotify = action.payload;
    },
    setLastRefreshTime: (state, action: PayloadAction<number>) => {
      state.lastRefreshTime = action.payload;
    },
  },
});

export const useTransactionUpdateState = () => {
  const dispatch = useAppDispatch();

  const hasTransactionUpdate = useAppSelector(
    (state) => state.transactionUpdate.hasTransactionUpdate,
  );
  const needToNotify = useAppSelector(
    (state) => state.transactionUpdate.needToNotify,
  );
  const lastRefreshTime = useAppSelector(
    (state) => state.transactionUpdate.lastRefreshTime,
  );

  const setHasTransactionUpdate = (newHasTransactionUpdate: boolean) => {
    dispatch(
      transactionUpdateSlice.actions.setHasTransactionUpdate(
        newHasTransactionUpdate,
      ),
    );
  };
  const setNeedToNotify = (newNeedToNotify: boolean) => {
    dispatch(transactionUpdateSlice.actions.setNeedToNotify(newNeedToNotify));
  };

  const reset = () => {
    setHasTransactionUpdate(initialState.hasTransactionUpdate);
    setNeedToNotify(initialState.needToNotify);
  };

  const setLastRefreshTime = (newLastRefreshTime: number) => {
    dispatch(
      transactionUpdateSlice.actions.setLastRefreshTime(newLastRefreshTime),
    );
  };

  return {
    hasTransactionUpdate,
    needToNotify,
    lastRefreshTime,
    setHasTransactionUpdate,
    setNeedToNotify,
    setLastRefreshTime,
    reset,
  };
};
